import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToGrow() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="ready-to-grow" className="dark bg-background text-foreground relative py-32 md:py-48 overflow-hidden flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1443870/img/grain_texture_overlay.png)] bg-cover bg-center bg-fixed opacity-10 mix-blend-overlay pointer-events-none" />
      
      {}
      <div className="absolute inset-0 bg-background/50 pointer-events-none" />

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-12 leading-[1.1]">
          Ready to grow on <br className="hidden md:block" />
          your own terms?
        </h2>
        
        <Button asChild size="lg" className="bg-ring text-background hover:bg-ring/90 text-lg md:text-xl px-10 py-8 h-auto rounded-sm uppercase tracking-widest font-bold shadow-xl hover:shadow-2xl transition-all">
          <Link to="https://edustrategygroup.com/schedule-your-strategy-session/">
            Start a Conversation
          </Link>
        </Button>
      </div>
    </section>;
}